import React from 'react';
import PropTypes from 'prop-types';
import { Carousel } from 'dibs-carousel';
import get from 'lodash.get';

import { SharedCarouselDot } from '../../sharedComponents/SharedCarouselDot/SharedCarouselDot';
import { HpRespPersonalizationPanel } from './HpRespPersonalizationPanel';

import styles from './HpRespPersonalizationPanelCarousel.scss';
import { HpSharedCarouselTracking } from '../HpSharedCarouselTracking/HpSharedCarouselTracking';
import {
    trackPersonalizationImpression,
    trackPersonalizationMount,
    trackPersonalizationPromoClick,
    trackPersonalizationDotClick,
} from './helpers/PersonalizationTracking';

const carouselClassNames = {
    wrapper: styles.carouselWrapper,
    list: styles.list,
    item: styles.carouselItem,
    listWrapper: styles.listWrapper,
    arrow: styles.arrow,
    arrowLeft: styles.arrowLeft,
    arrowRight: styles.arrowRight,
    dotsWrapper: styles.dotsWrapper,
};

function HpRespPersonalizationPanelCarousel({ items }) {
    return (
        <HpSharedCarouselTracking
            items={items}
            itemsPerPage={1}
            onInitialDisplay={() => trackPersonalizationMount()}
            onItemsImpression={({ visibleItems, index }) =>
                trackPersonalizationImpression({
                    //Passing visibleItems[0] because itemsPerPage === 1
                    recommendation: get(visibleItems, '[0].node'),
                    startIndex: index,
                })
            }
        >
            {({ handleIndexChange }) => (
                <Carousel
                    showDots
                    isInfinite={false}
                    slideCarouselItems
                    totalItems={items.length}
                    itemsPerPage={1}
                    step={1}
                    renderItem={({ index, isVisible }) => (
                        <HpRespPersonalizationPanel
                            item={items[index].node}
                            isVisible={isVisible}
                            pageIndex={index}
                        />
                    )}
                    renderDot={({ isCurrentDot, pageIndex }) => (
                        <SharedCarouselDot
                            isActive={isCurrentDot}
                            onClick={() => {
                                trackPersonalizationPromoClick();
                                trackPersonalizationDotClick({
                                    variant: get(items[pageIndex], 'node.variant'),
                                });
                            }}
                        />
                    )}
                    classNames={carouselClassNames}
                    onIndexChange={handleIndexChange}
                    onLeftArrowClick={() => trackPersonalizationPromoClick()}
                    onRightArrowClick={() => trackPersonalizationPromoClick()}
                />
            )}
        </HpSharedCarouselTracking>
    );
}

HpRespPersonalizationPanelCarousel.propTypes = {
    items: PropTypes.array.isRequired,
};

export { HpRespPersonalizationPanelCarousel };
